import React, { useState } from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';
import { DisplayAlignment, DisplaySize, ModalType } from '../../shared/enum/EnumRepository';
import OptimizedMoleculeImg from '../../shared/component/molecule/OptimizedMoleculeImg';
import { StyledImgProps } from '../../shared/dto/StyleCompRepository';
import downloadIcon from '../../asset/icon/download.png';
import { handleDownload } from '../../shared/util/download';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import fullIcon from '../../asset/icon/full_image.png';
import { useModalStore } from '../../shared/store/portal/modalStore';

interface WorkViewerImgProps {
  title: string;
  material: string;
  contertedStringSize: string;
  prodYear: string;
  allowDownload: boolean;
  convertedCloudFrontUrl: string;
}


const WorkViewerImg: React.FC<WorkViewerImgProps> = ({ 
  title, 
  material, 
  contertedStringSize, 
  prodYear, 
  allowDownload, 
  convertedCloudFrontUrl
  }) => {
  const { isEditMode } = useEditMode();
  const { isOwner } = useAuth();
  const handleImageChange = useWorkViewStore((s) => s.updateImage);
  const handleImageFileChange = useWorkViewStore((s) => s.updateImageFile);
  const pendingImage = useWorkViewStore((s) => s.pendingImage);
  const { setStandardModal } = useModalStore();
  const [isHovered, setIsHovered] = useState(false);
  const workFileLabel = [title, material, contertedStringSize, prodYear]
    .filter(Boolean)
    .join(', ');

  const showOriginImg = () => {
    setStandardModal({
      modalType: ModalType.ORIGIN_IMG,
      title: workFileLabel,
      value: convertedCloudFrontUrl,
      handleChange: () => { },
      option: allowDownload
    });
  }


  return (
    <WorkViewerImgWrapper
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <ImageWrap>
        <OptimizedMoleculeImg
          srcUrl={convertedCloudFrontUrl}
          alt={title}
          displaySize={DisplaySize.REGULAR}
          displayAlignment={DisplayAlignment.CENTER}
          handleChange={handleImageChange}
          handleFileChange={handleImageFileChange}
          imageFile={pendingImage?.file}
          StyledImg={WorkImage as React.ComponentType<StyledImgProps>}
          priority={true}
        />
      </ImageWrap>
      {!isEditMode && (
      <BtnContainer2 $isHovered={isHovered}>  
        {convertedCloudFrontUrl && isOwner && (
          <UniversalIconBtn 
            size="fit" 
            border={true} 
            backgroundImg={downloadIcon} 
            onClick={() => handleDownload(convertedCloudFrontUrl, workFileLabel)}
            />
        )}
        <UniversalIconBtn 
          size="fit" 
          border={true} 
          backgroundImg={fullIcon} 
          onClick={showOriginImg} />
      </BtnContainer2>
      )}
    </WorkViewerImgWrapper>
  );
}

const WorkViewerImgWrapper = styled.div`
  position: relative;
  height: fit-content;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-bottom: 20px;
`

const ImageWrap = styled.div`
  position: relative;
  display: inline-flex;
  max-width: 100%;
`;

const WorkImage = styled.img`
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 74vh;
  object-fit: contain;
  object-position: right center;
`;

const BtnContainer2 = styled.div<{ $isHovered: boolean }>`
  position: absolute;
  right: 0.5vh;
  top: 0.5vh;
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vh;
  opacity: ${({ $isHovered }) => ($isHovered ? 1 : 0)};
  cursor: ${({ $isHovered }) => ($isHovered ? 'pointer' : 'none')};
  pointer-events: ${({ $isHovered }) => ($isHovered ? 'auto' : 'none')};
  transition: all 0.3s ease-in-out;
`

export default WorkViewerImg;
